import React from "react";
import PropTypes from 'prop-types';

const ListRestaurant = ({ title, id, isSelected, onSelect}) => {
  
  const saveRestoEnCours = async (ideresto, nomresto) => {
    //ajout d'un restaurant en cours dans le local storage
    const userStr = localStorage.getItem("user");
    let user = userStr ? JSON.parse(userStr) : {};
    user.restoId = ideresto;
    user.restoNom = nomresto;
    localStorage.setItem("user", JSON.stringify(user));
    console.log("choix du resto: " + ideresto + nomresto);
  };

  const handleChange = () => {
    saveRestoEnCours(id, title);
    onSelect(id); // Set this restaurant as selected
  };
  return (
    <div
      className={`product-info ${isSelected ? 'active' : ''} default-cover`}
      style={{ cursor: 'pointer' }}
      onClick={handleChange}
    >
      <div className={`product-info ${isSelected ? 'active' : ''} default-cover `}>
        <div className=" row">       
          <label className="radio col-sm-1 col-md-2 col-lg-2 col-2">
            <input
              type="radio"
              name="selectedRestaurant"
              checked={isSelected}
              onChange={handleChange}
              style={{ position: 'relative' }}
                    />
          </label> 
          <h6 className=" mb-1 col-sm-11 col-md-10 col-lg-10 col-6">{title}</h6>      
         </div>  
                                             
      </div>
    </div>
  )
}

ListRestaurant.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default ListRestaurant;